var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.94493 2.00437C0.847338 1.89697 0.783 1.76357 0.759716 1.62033C0.736433 1.47709 0.755206 1.33017 0.813757 1.19739C0.872307 1.06461 0.968122 0.951668 1.08958 0.872256C1.21105 0.792845 1.35294 0.750376 1.49805 0.75H17.9981C18.1433 0.750014 18.2855 0.792221 18.4072 0.871491C18.529 0.950762 18.6251 1.06368 18.6838 1.19654C18.7426 1.32939 18.7616 1.47646 18.7383 1.61987C18.7151 1.76328 18.6508 1.89686 18.5531 2.00437L11.9981 9V14.4984C11.9981 14.6219 11.9677 14.7436 11.9095 14.8525C11.8513 14.9614 11.767 15.0543 11.6643 15.1228L8.6643 17.1225C8.55146 17.1978 8.42031 17.2411 8.28482 17.2477C8.14932 17.2544 8.01457 17.2241 7.89489 17.1603C7.77522 17.0964 7.67511 17.0012 7.60523 16.885C7.53534 16.7687 7.49831 16.6356 7.49805 16.5V9L0.94493 2.00437Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.eab37b656383696ee077c2a6229998c1.svg";
export { ForwardRef as ReactComponent };